<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
       <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#ffffff"
          text-color="#000000"
          active-text-color="#409EFF">
          <SidebarItem v-for="(item,index) in dataList" :key="index"  :item="item" />
        </el-menu>
    </el-scrollbar>
</template>

<script>
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  data() {
    return {
      dataList:[{
        'key':'overview',
        'title':this.$root.lang.navMenu.overview,
        'icon':'fa-bar-chart',
        'path':"/control/dashboard"
      },{
        'key':'device',
        'title':this.$root.lang.navMenu.deviceManage,
        'icon':'fa-tablet',
        'kindOne':[
            {
            'key':'device',
            'title':this.$root.lang.navMenu.device,
            'path':'/control/device/index'
            },
            {
            'key':'group',
            'title':this.$root.lang.navMenu.group,
            'path':'/control/device/group'
            },
            {
            'key':'task',
            'title':this.$root.lang.navMenu.task,
            'path':'/control/device/task'
            },
        ]
      },
      // {
      //   'key':'cert',
      //   'icon':'fa-book',
      //   'title':this.$root.lang.navMenu.certificate,
      //   'path':'/control/cert'
      // },
      {
        'key':'app',
        'icon':'fa-th-large',
        'title':this.$root.lang.navMenu.appManage,
        'path':'/control/app'
      },{
        'key':'user',
        'icon':'fa-user',
        'title':this.$root.lang.navMenu.user,
        'path':'/control/user'
      },{
        'key':'server',
        'icon':'fa-cloud',
        'title':this.$root.lang.navMenu.server,
        'kindOne':[
            {
            'key':'server-audio',
            'title':this.$root.lang.navMenu.serverAudio,
            'path':'/control/server/audio'
            }
        ]
      },
      // {
      //   'key':'help',
      //   'icon':'fa-file-o',
      //   'title':this.$root.lang.navMenu.helpDoc,
      //   'path':'/document'
      // }
      ]
    }
  },
  computed: {
    onRoutes(){
        return this.$root.defaultActive;
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getRoute(str) {
      if(this.$route.path.indexOf(str) > 0) return true;
      else return false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/Sidebar/index.vue